import './Fundamentals.css';
import React from "react";
import { Link } from 'react-router-dom';
import fundamentalsImage from '../assets/images/fundamentalsImage.png'

function Fundamentals(props) {
    return (
        <div className="">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <h1 className="storyHeaderText"> FUNDAMENTALS </h1>
            <img className="fundamentalsBackgroundImage" src={fundamentalsImage} alt="illustration of one shadow figures walking, with black oval outlines swirling around it" />
            <div className="row">
                <div className="fundamentalRectangle fundamentalRectangle1">
                    <div className="innerFundamentalRectangle">
                            <h2 className="innerBodyHeader"> What is Minimally Processed? </h2>
                             <p className="innerBodyBody"> The enemy of ultra-processed. We’re dedicated to helping you break up with ultra-processed foods and drinks.</p>
                            <a href="/story/welcomeTo">
                                <p className="buttonText"> LEARN MORE</p>
                            </a>
                    </div>
                </div>
                <div className="fundamentalRectangle fundamentalRectangle2">
                    <div className="innerFundamentalRectangle">
                            <h2 className="innerBodyHeader"> Meet Cierra, our founder </h2>
                            <a href="/story/founderStory">
                                <p className="buttonText"> READ MORE</p>
                            </a>
                    </div>
                </div>
                </div>
        </div>
    )
}

export default Fundamentals;